module.exports = __webpack_public_path__ + "static/media/blog_3.8ec0f542.jpg";